import Styled from "styled-components";


export const SignUPConatiner = Styled.div`
display: flex;
flex-direction: column;
width: 380px;

h2 {
    margin: 10px 0;
  }
`;

  
export const ButtonsContainer = Styled.div`
display: flex;
justify-content: space-between;
`;